import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Logout20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_867)'>
      <path
        d='M9.36616 0.823209C9.85432 0.335054 10.6458 0.335053 11.1339 0.823209L19.4268 9.1161C19.915 9.60426 19.915 10.3957 19.4268 10.8839L11.1339 19.1768C10.6458 19.6649 9.85431 19.6649 9.36616 19.1768L6.71971 16.5303L7.78037 15.4697L10.25 17.9393L18.1894 9.99999L10.25 2.06065L7.78037 4.53032L6.71971 3.46966L9.36616 0.823209Z'
        fill='currentColor'
      />
      <path
        d='M3.06059 9.25L13 9.25L13 10.75L3.06059 10.75L5.28026 12.9697L4.2196 14.0303L0.18927 10L4.2196 5.96967L5.28026 7.03033L3.06059 9.25Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_867'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Logout20.displayName = 'Logout20';
export default Logout20;
